import clsx from 'clsx';
import { FC } from 'react';
import { Image, LogoContainer, Types } from '@marriott/mi-ui-library';
import { MerchandisingHeroBannerAssetProps } from './MerchandisingHeroBannerAsset.types';
import { StyledVerticalImageContainer, StyledFontIcon, StyledLogoImage } from './MerchandisingHeroBannerAsset.styles';
import { URL_CONSTANTS } from '@marriott/shared/mi-helper-utils';
const { AssetVariation, ImageAspectRatio } = Types;
const { FONT_ICON } = AssetVariation;
const { SIZE_3x1 } = ImageAspectRatio;
const { PLACEHOLDER_IMAGE } = URL_CONSTANTS;
const { VERTICAL_IMAGE } = AssetVariation;
const MerchandisingHeroBannerAsset: FC<MerchandisingHeroBannerAssetProps> = props => {
  const {
    fileReferenceImageVertical,
    imgAltText,
    assetsVariation,
    verticalImageAltText,
    heroSize,
    fontIcon,
    fontIconAltText,
    logoImage,
    cobrandmathhero,
    isCopyBlockWidthWide,
    isLogoFlagEnabled,
    isMerchHero3X1 = false,
    isVariationsAvailable = false,
  } = props;

  const isVerticalImage = !!(assetsVariation && assetsVariation === VERTICAL_IMAGE && fileReferenceImageVertical);
  return (
    <>
      {isCopyBlockWidthWide && isVerticalImage && fileReferenceImageVertical && (
        <StyledVerticalImageContainer>
          <img
            src={fileReferenceImageVertical}
            className={`styled${assetsVariation}`}
            alt={verticalImageAltText}
            title={verticalImageAltText}
            data-src={PLACEHOLDER_IMAGE}
          />
        </StyledVerticalImageContainer>
      )}
      {!isVerticalImage && (
        <div className="row">
          {assetsVariation === FONT_ICON && fontIcon ? (
            isLogoFlagEnabled ? (
              <div className="col-12 col-md-4 col-lg-6">
                <LogoContainer
                  brand={`brand-logo-${fontIcon}`}
                  width={81}
                  height={54}
                  aspectRatio="3:2"
                  alignment="Center Left"
                  isLink={false}
                  color={'color'}
                />
              </div>
            ) : (
              <div className="col-12 col-md-4 col-lg-6">
                <StyledFontIcon
                  fontIcon={fontIcon}
                  className={clsx(`m-icon brand-logo-${fontIcon}`, {
                    'herobanner3X1__logo mb-0 p-0': isVariationsAvailable && isMerchHero3X1,
                    'herobanner3X1__logo p-0': !isVariationsAvailable && isMerchHero3X1,
                  })}
                  aria-labelledby={fontIconAltText || ''}
                  data-testid={fontIcon}
                />
              </div>
            )
          ) : (
            logoImage && (
              <StyledLogoImage
                className={clsx('credit-card', isMerchHero3X1 ? 'herobanner3X1__creditcard m-0' : '', {
                  'hb-flex': heroSize === SIZE_3x1 || isMerchHero3X1,
                  'herobanner3X1__logo mb-0 p-0': isMerchHero3X1 && isVariationsAvailable,
                  'herobanner3X1__logo p-0': !isVariationsAvailable && isMerchHero3X1,
                })}
                cobrandmathhero={cobrandmathhero as boolean}
              >
                <Image
                  title={imgAltText || 'Hero Card Image'}
                  customClass="logo-image"
                  loading="lazy"
                  defaultImageURL={logoImage}
                  altText={imgAltText}
                  dynamic={false}
                ></Image>
              </StyledLogoImage>
            )
          )}
        </div>
      )}
    </>
  );
};

export default MerchandisingHeroBannerAsset;
